<div class="select-channel-container">
    <div *ngIf="!assignedChannel" class="select-button" (click)="openChannelSelector()" [class.disabled]="!userCanEdit">
        {{ 'integration.settings.status-color.channel-select' | translate }}
    </div>
</div>

<ng-container *ngIf="assignedChannel">
    <app-system-integration-channel
        [assignedChannel]="assignedChannel"
        (onRemoveChannel)="removeAssignedChannel()"
        (onOpenSelector)="openChannelSelector()"></app-system-integration-channel>
</ng-container>

<ng-container *ngIf="showButtonIntercations">
    <app-button-element-interactions
        #buttonInteractions
        [element]="selectedElement"
        [elementSettings]="elementSettings">
    </app-button-element-interactions>
</ng-container>

<ng-container *ngIf="showStatusInteractions">
    <app-alarm-indicators
        #elementAlarms
        [assignedChannel]="assignedChannel"
        [activeFlags]="elementSettings?.activeFlags"
        [systemColors]="systemColors">
    </app-alarm-indicators>

    <app-range-indicators
        #elementRanges
        [assignedChannel]="assignedChannel"
        [foreignObject]="selectedElement"
        [rangesArray]="elementSettings?.ranges"
        [userCanEdit]="userCanEdit"
        [systemColors]="systemColors">
    </app-range-indicators>
</ng-container>

<ng-container *ngIf="showToggleInteractions">
    <app-toggle-interactions
        #toggleIntercations
        [element]="selectedElement"
        [elementSettings]="elementSettings"
        [assignedChannel]="assignedChannel">
    </app-toggle-interactions>

    <app-button-element-interactions
        #buttonToggleInteractions
        [element]="selectedElement"
        [showTitle]="false"
        [elementSettings]="elementSettings">
    </app-button-element-interactions>
</ng-container>

<ng-container *ngIf="showBarInteractions">
    <app-bar-element-settings
        #barInteractions
        [element]="selectedElement"
        [elementSettings]="elementSettings"
        [systemColors]="systemColors"
        [assignedChannel]="assignedChannel">
    </app-bar-element-settings>
</ng-container>

<ng-container *ngIf="isLoadingChannel">
    <app-loading-spinner class="spinner-component"></app-loading-spinner>
</ng-container>
